import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import _get from 'lodash/get';
import detectUserLocation from 'common/geo';
import GeoDuck from 'ducks/geo-duck';

const UserLocationDetector = () => {
  const dispatch = useDispatch();
  useEffect(
    () => {
      detectUserLocation()
        .then(data => {
          const latitude = _get(data, 'coords.latitude');
          const longitude = _get(data, 'coords.longitude');
          if (latitude && longitude) {
            dispatch(GeoDuck.creators.receiveUserLocation(latitude, longitude));
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(
            '[UserLocationDetector] failed to request user location, err:',
            err,
          );
        });
    },
    [dispatch],
  );
  return null;
};

export default UserLocationDetector;
